;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('coreTableColumnRowUser', tableColumnRowUser)

  /* @ngInject */
  function tableColumnRowUser (UserService) {
    return {
      restrict: 'E',
      scope: {
        value: '<',
        hasTitle: '<',
        positionLimit: '<',
        position: '<',
        textAlignment: '<'
      },
      templateUrl: '/core/directives/table-columns/table-column-row-user/table-column-row-user-directive.html?$$REVISION$$',
      link: function ($scope) {
        $scope.imageProfile = UserService.getUserProfileImage($scope.value.id, $scope.value.updatedAt || $scope.value.createdAt)
      }
    }
  }
})()
